import React, {useState} from 'react';
import { observer } from 'mobx-react'
import '../index.css';
import { changepopupdeleteDataset, changedatasetflag} from "../../../stores/GlobalState";
import Domen from "../../../stores/Domen";
import lang from "../../../lang"
const PopupDeleteDataset = observer(({id, deleteIdnum}) =>{
    const [langmenu, setLangmenu] = useState(localStorage.getItem("lang_site")||"en")
    const [langv, setLangv]= useState(langmenu=="de"?lang.de:lang.en)
    
    const deleteproductline = async (id) => {
        var token = localStorage.getItem("token");
        localStorage.setItem("countactivetime", Date.now());
        fetch(Domen.url + `dataset/`+id, {
            method: 'DELETE',
            headers: {
                'Authorization': token,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then(response => {
           changedatasetflag(0);
           changepopupdeleteDataset();
        })
        .catch(error => {
            console.error('There was an error with the fetch operation:', error);
        });
        
    };

    return (
        <div className="popupInfofon">
            <div className="popupInfo deleteProduct " style={{position: "fixed"}}>
                <div className='top-element'>
                    <div></div>
                    <div className='buttonspopup'>
                        <div className='buttonexit' onClick={changepopupdeleteDataset}>
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M18.7891 5.27441L6.24236 18.181" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M6.06055 5.45312L18.9671 17.9998" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='form-element'>
                    <div className='titlePopupDelete' dangerouslySetInnerHTML={{ __html: langv?.dataset?.popupdeletedataset?.text1 }}>
                    
                    </div>
                    <div className='buttonsPopupDelete refreshpopup'>
                        <div className='buttonPopupDelete' onClick={changepopupdeleteDataset}>
                            {langv?.dataset?.popupdeletedataset?.text2}
                        </div>
                        <div className='buttonPopupDelete add_refresh' onClick={() =>deleteproductline(id)}>
                            {langv?.dataset?.popupdeletedataset?.text3}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default PopupDeleteDataset;
